import { render, staticRenderFns } from "./LmSettingsIcon.vue?vue&type=template&id=280a189e&"
import script from "./LmSettingsIcon.vue?vue&type=script&lang=js&"
export * from "./LmSettingsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports